/* src/app/views/smart-filters/components/smart-filter-card-row/smart-filter-card/smart-filter-card.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.smart-filter-card {
  position: relative;
  display: flex;
  word-wrap: break-word;
  background-color: #f2f2f2;
  border-radius: 1rem;
  height: 2.25rem;
  padding: 0 0.5rem 0 0.5rem;
}
.smart-filter-category-icon {
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
}
.smart-filter-category-icon-background {
  background-color: #2c4058;
}
.content-container {
  display: flex;
  align-items: center;
}
.text-container {
  display: block;
}
.smart-filter-name {
  font-size: 0.875rem;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
  line-height: 0.9rem;
  width: max-content;
}
.x-icon {
  height: 1rem;
  width: 1rem;
  margin-left: 0.5rem;
  cursor: pointer;
}
/*# sourceMappingURL=smart-filter-card.component.css.map */
